import { Component, OnInit } from '@angular/core';
import { MatCardModule } from "@angular/material/card";
import { AuthService } from '@app/core/services/auth.service';
import { TableConfig } from '@app/interfaces/table';
import { GlobalUnitModel } from '@app/models/system-settings';
import { TableComponent, TitleComponent } from "@app/shared/components";
import { BaseFilterComponent } from '@app/shared/components/base-filter.component';
import { FiltersComponent } from "@app/shared/forms/components";
import { GlobalUnitService } from '@app/shared/services';

@Component({
	selector: 'sb-switch-unit-login',
	standalone: true,
	imports: [TitleComponent, MatCardModule, FiltersComponent, TableComponent],
	template: `
		<sl-title title="Select Another Unit" hidePendo="true"></sl-title>
		<mat-card class="linq-card--legacy">
			<sl-filters [filters]="filters" searchOnly="true" (filtersUpdated)="applyFilter($event)">
			</sl-filters>
			<sl-table [config]="tableConfig" [data]="data" [filters]="filters"></sl-table>
		</mat-card>
`,
})
export class SwitchUnitLoginComponent extends BaseFilterComponent<GlobalUnitModel> implements OnInit {
	tableConfig: TableConfig<GlobalUnitModel> = this.getUnitListConfig();
	data: GlobalUnitModel[] = [];
	private currentUnitId = '';

	constructor(private readonly globalUnitService: GlobalUnitService,
		private readonly authService: AuthService,
	) {
		super();
	}

	ngOnInit(): void {
		this.currentUnitId = this.authService.authentication.unitId;
		this.loadData();
	}

	private getUnitListConfig(): TableConfig<GlobalUnitModel> {
		return {
			...this.tableConfig,
			columns: [
				{
					header: 'Unit ID',
					key: 'UnitId',
				},
				{
					header: 'Unit Name',
					key: 'UnitName',
				},
			],
			defaultSortField: 'UnitId',
			defaultSortDirection: 'asc',
			selectedId: null,
			showRowSelect: false,
			showRowActions: false,
			onRowClick: (row: GlobalUnitModel) => this.loginToUnit(row),
		} as TableConfig<GlobalUnitModel>;
	}

	protected loginToUnit(row: GlobalUnitModel): any {
		this.tableConfig.selectedId = row.Id;
		this.authService.login(row.UnitId);
	}

	protected refresh?(): void {
		this.loadData();
	}

	private loadData() {
		this.data = [];
		this.globalUnitService.getListByUser().subscribe((response) => {
			this.filters = { search: '' };
			this.data = response.data.filter((unit) => unit.UnitId !== this.currentUnitId);
		});
	}
}
